/* eslint complexity: ["error", 40] */

import React, {Fragment, useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter, Redirect} from 'react-router-dom';
import {Button, Container, Fade, Form} from 'react-bootstrap';
import CommonMetaTag from './common-meta-tag';
import {push} from 'connected-react-router';
import {
  getRtvVideos,
  getRtvPartnerVideos,
  showPlayerNewSubscriptionModal,
  subscriptionSelected,
  partnerSelected,
  showPlayerHowPurchaseModal,
  rtvChannelSelected,
  removeRtvChannelFromFavourite,
  addRtvChannelToFavourite,
  selectCategory,
  getLiveVideos
} from '../actions/player';
import PlayerHowPurchase from './player-how-purchase';
import Configuration from '../config';
import {subscriptionStatuses, subscriptionKind} from '../constants';
import PlayerNewSubscription from './player-new-subscription';
import PlayerInsufficientFunds from './player-insufficient-funds';
import {useTranslation, Trans} from 'react-i18next';
import { showMessage } from '../actions/messages';
import rIcon from '../images/Replayer_favicon.png'
import allChannelsIcon from '../images/apps_white_24dp.svg'
import Dialog from 'react-bootstrap-dialog';


const PlayerReplayerTvHome = ({
  token,
  partners,
  profile,
  goto,
  showReplayerTV,
  showPlayerHowPurchaseModal,
  subscriptions,
  favouriteRtvChannels,
  toggleFavouriteRtvChannel,
  showReplayerTVPartnerVideo,
  rtvCategories,
  selectCategory,
  deselectCategory,
  selectedCategory,
  gotoLiveVideos
}) => {
  const {t, i18n} = useTranslation();

  const [channelFilter, setchannelFilter] = useState("");

  if (token === null) {
    return (
      <Redirect to="/login"/>
    );
  }

  const getSubscriptionStatus = (partner, channel) => {
    if (subscriptions) {
      const sub = subscriptions.subscriptions.find(s => s.partner === partner.uid && s.rtv_channel_id === channel.id);
      if (sub && new Date(sub.expiry) >= new Date()) {
        return {status: subscriptionStatuses.valid};
      }

      const unlimitedSubscription = subscriptions.subscriptions.find(s => new Date(s.expiry) >= new Date() && s.kind === subscriptionKind.rtvUnlimited);
      if (unlimitedSubscription) {
        return {status: subscriptionStatuses.unlimited};
      }

      if (sub && new Date(sub.expiry) < new Date()) {
        return {status: subscriptionStatuses.expired, subscriptionId: sub.id};
      }

      return {status: subscriptionStatuses.noSubscription};
    }

    return {status: subscriptionStatuses.noSubscription};
  };

  const isFavouriteRtvChannel = rtv_channel_id => favouriteRtvChannels.some(c => c.id === rtv_channel_id);

  const getCategoryLogo = (categoryId, imageName) => {
    if (imageName.length > 0) {
      return `${Configuration.apiEndPoint}/admin/categories/image/${categoryId}?load=${imageName[0]}`;
    }
    return rIcon;
  };

  let dialog = null;

  const showRtvInfo = () => {
    dialog.show({
      title: t('WELCOME_TO_RTV'),
      body: <Trans i18nKey='REPLAYER_TV_INFO'/>,
      actions: [
        Dialog.Action(
          t('CLOSE_BUTTON'),
          null,
          'btn btn_red_outline_rp'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  const renderEmptyPageString = () => {
    let channelNumber = 0;
    partners.forEach(p => {
      p.rtvChannels.forEach(c => {
        if((channelFilter === "" || c.name.toLowerCase().indexOf(channelFilter.toLowerCase()) > -1) && (Object.keys(selectedCategory).length === 0 || selectedCategory.rtvChannels.includes(c.id))){
          channelNumber++;
        }
      });
    });
    if (channelNumber === 0) {
      return <h6>{t('SEARCH_CHANNEL_FAILED')}</h6>;
    }
    return null;
  }

  return (
    <Fragment>
      <CommonMetaTag/>
      <Fade in appear className="bg_white" style={{transition: 'opacity 0.30s linear', minHeight: 1000}}>
        <Container fluid className="presentation-container">
        <div className="page-header header-filter clear-filter replayertv_sportcenter_hero_rp" data-parallax="true">
            <div className="replayertv_sportcenter_hero_overlay_rp"/>
          </div>
          <div className="main main_raised_rp">
            <div className="section">
              <div className="container pt-5">
                <div className="row mb-4">
                  <div className="col-12">
                    <div class="wrapper" style={{paddingBottom: 20}}>
                      <a class="cta" href="#" onClick={gotoLiveVideos}>
                        <span className="live-now-span" >LIVE NOW</span>
                        <span className="live-now-span">
                          <svg width="66px" height="43px" viewBox="0 0 66 43" version="1.1">
                            <g id="arrow" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <path class="one" d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z" fill="#DD004A"></path>
                              <path class="two" d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z" fill="#DD004A"></path>
                              <path class="three" d="M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z" fill="#DD004A"></path>
                            </g>
                          </svg>
                        </span> 
                      </a>
                    </div>
                    <div className="detail_head_rp video_store_head rounded">
                      <div>
                        <h4 className="section_title_neg_rp">{t('REPLAYER_TV')}</h4>
                        <div className="rtv_info_btn" onClick={showRtvInfo}/>
                      </div>
                      <p>{t('DISCOVER_SPORTS_CENTERS_CHANNELS')}</p>
                      <Form>
                      <Form.Group>
                        <Form.Control name="channelFilter" style={{maxWidth: 250}} placeholder={t('CHANNEL_SEARCH')} type="text" maxLength="50" onChange={e => setchannelFilter(e.target.value)} onKeyPress={event => {if (event.key === 'Enter') {event.preventDefault();}}}/>
                      </Form.Group>
                      </Form>
                      {renderEmptyPageString()}
                      <hr className="hr_blue"/>
                      <div className="row">
                      {rtvCategories ?
                        <div className="col-lg-12 mt-sm-2">
                          <Button onClick={() => selectCategory({})} variant="categoryButton" style={{borderColor: "white", backgroundColor: Object.keys(selectedCategory).length === 0 ? "#FFFFff40" : null}}>
                              <img style={{height: 40, width: 40}} src={allChannelsIcon} alt={t('ALL_CHANNELS_LOGO')}/>
                              {" " + t('ALL_CHANNELS')}
                            </Button>
                          {rtvCategories.map(c => 
                            <Button key={c.id} onClick={() => c.id === selectedCategory.id ? deselectCategory() : selectCategory(c)} variant="categoryButton" style={{borderColor: c.color, backgroundColor: c.id === selectedCategory.id ? c.color : null}}>
                              <img style={{height: 40, width: 40}} src={getCategoryLogo(c.id, c.imageName)} alt={t('CATEGORY_LOGO')}/>
                              {" " + c.label}
                            </Button>
                          )}
                        </div>
                        : null}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  {partners.map(p => p.rtvChannels.map(channel =>
                    (
                      (channelFilter === "" || channel.name.toLowerCase().indexOf(channelFilter.toLowerCase()) > -1) && (Object.keys(selectedCategory).length === 0 || selectedCategory.rtvChannels.includes(channel.id)) ?
                      <div key={channel.id} className="col-md-6 col-lg-4 mb-2 mb-md-4 card-group">
                        <a href="#" className={channel.type === 0 ? "card video_store_bg_rp ease_fx" : "card video_store_bg_rp_specialist ease_fx"} onClick={channel.type === 0 ? showReplayerTV(p, channel, getSubscriptionStatus(p, channel)) : showReplayerTVPartnerVideo(p, channel, getSubscriptionStatus(p, channel))}>
                          <div className="card-horizontal">
                            <div className="col-sm-3 col-lg-4 pl-0 pr-0 video_store_logo_bg_rp d-flex align-items-stretch justify-content-center">
                              {
                                channel.logoNames && channel.logoNames.length > 0 ?
                                  <div className="align-self-center">
                                    <img
                                      className="img-fluid"
                                      src={`${Configuration.apiEndPoint}/partners/rtv_channels/${channel.id}/images?load=${channel.logoNames[0]}`}
                                      alt={t('LOGO')}
                                    />
                                  </div> :
                                  p.storeImage && p.storeImage.length > 0 ?
                                  <div className="align-self-center">
                                    <img
                                      className="img-fluid"
                                      src={`${Configuration.apiEndPoint}/images/${p.uid}?load=${p.storeImage[0]}`}
                                      alt={t('LOGO')}
                                    />
                                  </div> :
                                  <div className="align-self-center video_store_nologo_overlay_rp"/>
                              }
                            </div>
                            <div className="card-body d-flex align-items-center col-sm-9 col-lg-8">
                              <h5 className="card-title mb-0">{channel.name}</h5>                              
                            </div>
                            <div className="card-body d-flex align-items-center col-sm-1 col-lg-1">
                              {
                                isFavouriteRtvChannel(channel.id) ?
                                  <div className="white_favorites_card_heart_btn_active" onClick={e => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    toggleFavouriteRtvChannel(channel.id, true);
                                  }}/> :
                                  <div className="white_favorites_card_heart_btn" onClick={e => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    toggleFavouriteRtvChannel(channel.id, false);
                                  }}/>
                              }
                            </div>
                          </div>
                        </a>
                      </div>
                    : null)
                  ))}
                </div>
              </div>
            </div>
          </div>
          <PlayerNewSubscription/>
          <PlayerInsufficientFunds/>
        </Container>
      </Fade>
      <PlayerHowPurchase/>
      <Dialog
        ref={el => {
          dialog = el;
        }}/>
    </Fragment>
  );
};

PlayerReplayerTvHome.propTypes = {
  token: PropTypes.string,
  partners: PropTypes.array,
  profile: PropTypes.object.isRequired,
  goto: PropTypes.func.isRequired,
  showReplayerTV: PropTypes.func.isRequired,
  showPlayerHowPurchaseModal: PropTypes.func.isRequired,
  subscriptions: PropTypes.object,
  favouriteRtvChannels: PropTypes.array
};

PlayerReplayerTvHome.defaultProps = {
  token: null,
  partners: [],
  subscriptions: {},
  favouriteRtvChannels: []
};

const mapStateToProps = ({login: {token, profile}, player: {partners, subscriptions, favouriteRtvChannels, rtvCategories, selectedCategory}}) => ({
  token,
  profile,
  partners,
  subscriptions,
  favouriteRtvChannels,
  rtvCategories,
  selectedCategory
});

const mapDispatchToProps = dispatch => ({
  showPlayerHowPurchaseModal: () => {
    dispatch(showPlayerHowPurchaseModal());
  },
  showReplayerTV: (partner, rtvChannel, subscriptionStatus) => () => {    
    dispatch(partnerSelected(partner));
    dispatch(rtvChannelSelected(rtvChannel));
    if (subscriptionStatus.status === subscriptionStatuses.valid || subscriptionStatus.status === subscriptionStatuses.unlimited || (rtvChannel.rtvPrice === 0 && rtvChannel.rtvPriceEvent === 0 && rtvChannel.rtvPriceMembership === 0)) {
      dispatch(getRtvVideos(partner.uid, rtvChannel.id));
      dispatch(push('/player-replayer-tv'));
      return;
    }

    if (rtvChannel.blocked) {
      dispatch(showMessage('RTV_CHANNELS', 'RTV_CHANNEL_IS_BLOCKED'));
      return;
    }
    
    dispatch(showPlayerNewSubscriptionModal());
    return;
  },
  showReplayerTVPartnerVideo: (partner, rtvChannel, subscriptionStatus) => () => {    
    dispatch(partnerSelected(partner));
    dispatch(rtvChannelSelected(rtvChannel));
    if (subscriptionStatus.status === subscriptionStatuses.valid || (rtvChannel.rtvPrice === 0 && rtvChannel.rtvPriceEvent === 0 && rtvChannel.rtvPriceMembership === 0)) {
      dispatch(getRtvPartnerVideos(partner.uid, rtvChannel.id));
      dispatch(push('/player-replayer-tv-video-partner'));
      return;
    }

    if (rtvChannel.blocked) {
      dispatch(showMessage('RTV_CHANNELS', 'RTV_CHANNEL_IS_BLOCKED'));
      return;
    }
    
    dispatch(showPlayerNewSubscriptionModal());
    return;
  },
  goto: (path, action = null) => e => {
    e.preventDefault();
    if (action) {
      dispatch(action());
    }

    dispatch(push(path));
  },
  toggleFavouriteRtvChannel: (rtv_channel_id, isFavourite) => {
    if (isFavourite) {
      dispatch(removeRtvChannelFromFavourite(rtv_channel_id));
    } else {
      dispatch(addRtvChannelToFavourite(rtv_channel_id));
    }
  },
  selectCategory: category => {
    dispatch(selectCategory(category));
  },
  deselectCategory: () => {
    dispatch(selectCategory({}));
  },
  gotoLiveVideos: () => {
    dispatch(getLiveVideos());
    dispatch(push('/player-live-videos'));
  }
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PlayerReplayerTvHome));
